import SuperFetch from '../../superFetch.js';

class VersionApi {
  /**
   *  [버전 전체 리스트] 버전 전체 리스트 요청하기
   */
  getVersionList = (data) => SuperFetch.post('/version/list', data);

  /**
   * [버전 등록] 버전 등록 요청하기
   */
  insertVersion = (data) => SuperFetch.post('/version/insert', data);

  /**
   * [버전 편집] 버전 편집 요청하기
   */
  editVersion = (data) => SuperFetch.post('/version/edit', data);

  /**
   * [버전 삭제] 버전 삭제 요청하기
   */
  deleteVersion = (data) => SuperFetch.post('/version/delete', data);

  /**
   * [버전 상세] 버전 상세 요청하기
   */
  getVersionDetail = (data) => SuperFetch.post('/version/detail', data);
}

export default new VersionApi();
